import { EntityType } from '@miq/shared-models';
import { displayRangeButtonsModel, RangeBtnFilters } from './range-button.model';
import { LeaseColumns, TenancyColumns } from '@miq/catalog';
export const displayRangeButtons: displayRangeButtonsModel = {
  [EntityType.LeaseComp]: [
    {
      name: 'Break Date',
      label: 'Lease Break Date',
      value: true,
      idx: 0,
      id: '17124',
      associations: true,
      firstChild: true,
    },
    {
      name: 'End Date',
      label: 'Lease End',
      value: true,
      idx: 1,
      id: '1635',
      associations: false,
    },
    {
      name: 'Review Date',
      label: 'Rent Review Date',
      value: false,
      idx: 2,
      id: '3949',
      associations: false,
      lastChild: true,
    },
  ],
  [EntityType.Tenancy]: [
    {
      name: 'Break Date',
      label: 'Lease Break Date',
      value: true,
      idx: 0,
      id: '18440',
      associations: false,
      firstChild: true,
    },
    {
      name: 'End Date',
      label: 'Lease End',
      value: true,
      idx: 1,
      id: '3784',
      associations: false,
    },
    {
      name: 'Review Date',
      label: 'Rent Review Date',
      value: false,
      idx: 2,
      id: '18439',
      associations: false,
      lastChild: true,
    },
  ],
};
export const payLoadForRangeBtn: RangeBtnFilters = {
  [EntityType.LeaseComp]: [
    {
      type: 'range',
      field: 'arrangement_end_date',
      key: 1635,
      dataType: 'date',
      name: 'Lease End',
      values: {
        from: null,
        to: null,
      },
      rangeButton: true,
      rangeButtonId: LeaseColumns.LeaseDetails_LeaseEvents,
    },
    {
      type: 'range',
      field: 'arrangement_options/arrangement_option_start_date',
      key: 3949,
      dataType: 'date',
      name: 'Rent Review Date',
      values: {
        from: null,
        to: null,
      },
      rangeButton: true,
      rangeButtonId: LeaseColumns.LeaseDetails_LeaseEvents,
    },
    {
      type: 'group',
      field: 'arrangement_options/arrangement_option_start_date',
      key: 17124,
      dataType: 'date',
      rangeButton: true,
      rangeButtonId: LeaseColumns.LeaseDetails_LeaseEvents,
      values: [
        {
          type: 'multi',
          field: 'arrangement_options/arrangement_option_executor_type_desc',
          key: 17125,
          dataType: 'text',
          condition: "arrangement_option_type_desc='break'",
        },
        {
          type: 'range',
          field: 'arrangement_options/arrangement_option_start_date',
          key: 17124,
          values: { from: null, to: null, enumSelection: null },
          dataType: 'date',
        },
      ],
    },
  ],
  [EntityType.Tenancy]: [
    {
      type: 'range',
      field: 'property_space/lease_expiration_date',
      key: 3784,
      dataType: 'date',
      name: 'End Date',
      values: {
        from: null,
        to: null,
      },
      rangeButton: true,
      rangeButtonId: TenancyColumns.Tenancy_LeaseEvents,
    },
    {
      type: 'range',
      field: 'property_space/arrangement_options/arrangement_option_start_date',
      key: 18440,
      dataType: 'date',
      name: 'Lease Break Date',
      values: {
        from: null,
        to: null,
      },
      rangeButton: true,
      rangeButtonId: TenancyColumns.Tenancy_LeaseEvents,
    },
    {
      type: 'range',
      field: 'property_space/arrangement_options/arrangement_option_start_date',
      key: 18439,
      dataType: 'date',
      name: 'Rent Review Date',
      values: {
        from: null,
        to: null,
      },
      rangeButton: true,
      rangeButtonId: TenancyColumns.Tenancy_LeaseEvents,
    },
  ],
};
export const rangeButtonFilterList = {
  [EntityType.LeaseComp]: [
    {
      type: 'range-buttons',
      key: LeaseColumns.LeaseDetails_LeaseEvents,
      field: 'arrangement_end_date',
      dataType: 'date',
      name: 'Lease Events',
    },
  ],
  [EntityType.Tenancy]: [
    {
      type: 'range-buttons',
      key: TenancyColumns.Tenancy_LeaseEvents,
      field: 'property_space/lease_expiration_date',
      dataType: 'date',
      name: 'Lease Events',
    },
  ],
};
export const displayRangeButtonsList = {
  [EntityType.LeaseComp]: ['1635', '3949', '17124'],
  [EntityType.Tenancy]: ['3784', '18439', '18440'],
};
export const rangeButtonDefaultconfigValues = {
  [EntityType.LeaseComp]: {
    17124: true,
    1635: true,
    3949: false,
    from: null,
    to: null,
  },
  [EntityType.Tenancy]: {
    18440: true,
    3784: true,
    18439: false,
    from: null,
    to: null,
  },
};
export enum FilterKeys {
  From = 'from',
  To = 'to',
  IncludeEmpty = 'includeEmpty',
  ExcludeEmpty = 'excludeEmpty',
  Values = 'values',
  // Add more keys here as needed
}
